import React from 'react';
import { BACKEND_URL } from '../../constants';
class LoginConditional extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const githubLink = (
        /* eslint-disable-next-line react/jsx-no-target-blank */
        React.createElement("a", { href: `${BACKEND_URL}auth/github`, target: "_blank" }, "Login with GitHub"));
        return React.createElement(React.Fragment, null, this.props.isAuthenticated ? this.props.children : React.createElement("span", null,
            githubLink,
            " to use the Gist feature."));
    }
}
export default LoginConditional;
